module.exports = __webpack_public_path__ + "media/large_bottle_hall.c1433a8b.wav";